import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent {
  @Input() links = [];

  expandLinkSubLinks(event: Event, link) {
    event.stopPropagation();

    link.expanded = true;
  }

  closeLinkSubLinks(event: Event, link) {
    event.stopPropagation();

    link.expanded = false;
  }

  goToLink(url: string) {
    window.open(url, '_blank');
  }
}
